import { gql } from '@apollo/client';
import useQuery from 'api/hooks/useQuery';
import permissions from 'api/Apollo/permissions';

import tag from './tag';

export const TAGS_QUERY = 'Tags';

export const GET_TAGS = gql`
  query ${TAGS_QUERY}($type: tag_types_enum!) {
    tags(where: { type: { _eq: $type } }, order_by: { label: asc }) {
      ...tag
    }
  }
  ${tag}
`;

export default function useQueryTags({ type, ...options } = {}) {
  const { data, loading, error, isAllowed, refetch } = useQuery(GET_TAGS, {
    variables: { type },
    context: { permission: permissions.readTags },
    ...options,
  });

  return {
    data: data?.tags ?? [],
    loading,
    isAllowed,
    error,
    refetch,
  };
}
